import { HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import Typography from '@/components/base/Typography'
import { useLenis } from '@/contexts/lenis'
import { useLoaderStore } from '@/store/loader'
import { horizontalLoop } from '@/utils'

export type ImageParagraphProps = HTMLAttributes<HTMLElement> &
  Partial<{
    text: string
  }>

const MarqueeText = ({ text, ...props }: ImageParagraphProps) => {
  const wrapper = useRef<HTMLDivElement>(null!)
  const loaded = useLoaderStore((state) => state.pageLoaded)
  const { lenis } = useLenis()

  useGSAP(
    (context) => {
      if (!lenis || !loaded) return
      const selector = context?.selector || gsap.utils.selector(wrapper)
      const text = selector('[data-motion-text]')

      horizontalLoop(text, {
        repeat: -1,
        paused: false
      })

      return () => {}
    },
    {
      dependencies: [lenis, loaded],
      scope: wrapper,
      revertOnUpdate: true
    }
  )

  return text ? (
    <section
      ref={wrapper}
      {...props}
      className="overflow-hidden bg-primary py-[1.6rem] text-foreground"
    >
      <div className="flex">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="flex" data-motion-text>
            <Typography variant="h4" className="mx-[2rem]">
              *
            </Typography>
            <Typography variant="h4" className="whitespace-nowrap uppercase">
              {text}
            </Typography>
          </div>
        ))}
      </div>
    </section>
  ) : null
}

export default MarqueeText
